import { createContext, useContext } from 'react';

import { CheckoutReason } from '~features/annals';
import {
	Level,
	Logger,
	LoggerMessages,
	LoggerServices,
} from '~shared/services/logger';

import type { TBotPaywallContext } from './types';

export const BotPaywallContext = createContext<TBotPaywallContext>({
	isOpen: false,
	canSendMessages: false,
	botId: undefined,
	checkoutReason: CheckoutReason.Menu,
	openBotPaywall: () => undefined,
	closeBotPaywall: () => undefined,
});

export const useBotPaywallContext = () => {
	const context = useContext(BotPaywallContext);
	if (!context) {
		Logger.shared.log(
			Level.error,
			LoggerServices.BotService,
			LoggerMessages.BotContextError,
			{}
		);
		throw Error('BotPaywallContext context no context Provider');
	}
	return context;
};
